import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import Btn from '../gameItems/Btn';
import ABCyaLib from '@abcya/abcya_lib';

/**
 * This is your first scene.
 */
export default class Intro extends Phaser.Scene
{
    static get KEY() { return 'Intro'; }

    preload()
    {
        // preload your assets here, if needed
    }

    create()
    {
        gameData.GAME_STATE = "Intro";
        this.introOver = false;
        this.levels = [];

        this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

        ABCyaPhaser.Audio.playOneShot("Jingle", this, .1, -1);

        this.bg = ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, "bg", this);
        this.jr = ABCyaPhaser.Images.addImage(this.mid.x, (this.mid.y*2)/3, "JrLogo", this);
        this.pick1 = ABCyaPhaser.Images.addImage(0, (this.mid.y*2)/3, "PickAxe", this);
        this.pick2 = ABCyaPhaser.Images.addImage(0, (this.mid.y*2)/3, "PickAxe", this);
        this.title = ABCyaPhaser.Images.addImage(0, (this.mid.y*2)/3, "MathMineLogo", this);
        this.top = ABCyaPhaser.Images.addImage(0, (this.mid.y*2)/3, "TopBar", this);
        this.bottom = ABCyaPhaser.Images.addImage(0, (this.mid.y*2)/3, "BottomBar", this);

        this.playBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "StartBtn", null, ()=>{
            this.playBtn.setEnabled(false);
            this.introAnim();
        }, this, {disabledTint:"0xFFFFFF"}).setEnabled(false);

        this.top.x = this.mid.x - 3;
        this.bottom.x = this.mid.x - 3;
        this.top.y = -this.top.height/2 - 7;
        this.bottom.y = (this.mid.y*2) + this.top.height/2;

        this.pick1.name = "pick1";
        this.pick2.name = "pick2";
        this.pick1.y = this.pick2.y = (this.mid.y*2)/3;
        this.pick1.x = -this.pick1.width;
        this.pick2.x = (this.mid.x*2) + this.pick2.width;
        this.title.x = this.mid.x;
        this.title.y = (this.mid.y*2)/2.25 - 70;
        this.playBtn.x = this.mid.x;
        this.playBtn.y = this.title.y + this.title.height/2 + 240;
        this.jr.y = this.title.y - this.jr.height + 50;// + this.title.getBounds().height/2;
        this.jr.alpha = 0;

        this.pick2.scaleX *= -1;
        this.title.scaleX = this.title.scaleY = 0;
        this.playBtn.alpha = 0;

        this.introAnim("start");
    }

    introAnim(type){
        if(type == "start"){
            //console.log("starting intro");
            const ang = {
                getEnd: function ()
                {
                    return 0;
                },

                getStart: function (target)
                {
                    const a = target.name == "pick1" ? -360 : 360;
                    return a;
                }
            };

            ABCyaPhaser.Tweens.addTween(this.pick1, 500, {x:(this.mid.x*2) - (this.mid.x*2)/4, angle:ang, delay:500}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this.pick2, 500, {x:(this.mid.x*2)/4, angle:ang, delay:500}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this.top, 1000, {y:7}, Phaser.Math.Easing.Bounce.Out);
            ABCyaPhaser.Tweens.addTween(this.bottom, 1000, {y:(this.mid.y*2) - this.top.height/2 + 20}, Phaser.Math.Easing.Bounce.Out);
            ABCyaPhaser.Tweens.addTween(this.title, 1000, {scale:1}, Phaser.Math.Easing.Back.Out, ()=>{this.introAnim("jr");});
        } else if(type == "jr"){
            this.jr.alpha = 1;
            ABCyaPhaser.Tweens.addTween(this.playBtn, 500, {alpha:1}, Phaser.Math.Easing.Linear, ()=>{this.navReady();});
            ABCyaPhaser.Tweens.addTween(this.jr, 1000, {y:this.title.y + this.jr.height/2 + 40}, Phaser.Math.Easing.Bounce.Out);
        } else {
            ABCyaPhaser.Audio.playOneShot("Click", this);

            //console.log("exiting intro");
            ABCyaPhaser.Tweens.addTween(this.pick1, 500, {x:(this.mid.x*2) + this.pick1.width, angle:90}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this.pick2, 500, {x:-this.pick1.width, angle:-90}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this.title, 500, {scale:0}, Phaser.Math.Easing.Back.In);
            ABCyaPhaser.Tweens.addTween(this.jr, 500, {y:this.title.y - this.jr.height + 50, alpha:0}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this.playBtn, 500, {alpha:0}, Phaser.Math.Easing.Linear, ()=>{this.destroyIntro();});
        }
    };

    createLevels(){
        this.checkStorage();

        for(let i = 0; i < 9; i++){
            let level;
            if(gameData.LEVELS[i].locked == false){
                level = new Btn(this, i, false, gameData.LEVELS[i].score).setScale(0);
            } else {
                level = new Btn(this, i, true, gameData.LEVELS[i].score).setScale(0);
            }

            this.levels.push(level);
        }

        for(let l = 0; l < this.levels.length; l++){
            ABCyaPhaser.Tweens.addTween(this.levels[l], 1000, {scale:1, delay:75*l}, Phaser.Math.Easing.Back.Out);

            if(l < 3){
                this.levels[l].x = (this.levels[l].body.width/2 + 60) + ((this.levels[l].body.width + 50) * l);
                this.levels[l].y = this.levels[l].body.height + 60;
            }
            if(l >= 3 && l < 6){
                this.levels[l].x = (this.levels[l].body.width/2 + 60) + ((this.levels[l].body.width + 50) * (l - 3));
                this.levels[l].y = (this.levels[l].body.height + 50) * 2;
            }
            if(l >= 6 && l < 9){
                this.levels[l].x = (this.levels[l].body.width/2 + 60) + ((this.levels[l].body.width + 50) * (l - 6));
                this.levels[l].y = (this.levels[l].body.height + 50) * 3;
            }
        }
    };

    checkStorage()
    {
        let DATA = ABCyaLib.Storage.getObject("levels");
        const lvls = [{locked:false, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0},
            {locked:true, score:0}];
        if(!DATA || DATA == [] || DATA.length == 0){
            console.log("NO LEVELS BEATEN");
            ABCyaLib.Storage.saveObject("levels", lvls);
        }
        DATA = ABCyaLib.Storage.getObject("levels") ?? lvls;
        gameData.LEVELS = DATA;
    }

    navReady(){
        this.playBtn.setEnabled(true);
        this.introOver = true;
    };

    destroyIntro(){
        console.log("destroying Intro");
        
        this.sound.stopAll();
        this.sound.removeAll();
        this.tweens.killAll();

        this.scene.start("Game");
    };
}